import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import MetaTags from "react-meta-tags";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CallIcon from "@material-ui/icons/Call";
import EmailIcon from "@material-ui/icons/Email";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { postEmailToAdmin, sendEmailToSender } from "../../action/mailing";

export default function Contact() {
  const { register, handleSubmit, errors, clearError, setError } = useForm();
  const [active, setActive] = useState(true);

  const [open, setOpen] = useState(false);
  const [openTime, setOpenTime] = useState(false);
  const [namaActive, setNamaActive] = useState(true);
  const [emailActive, setEmailActive] = useState(true);
  const [notesActive, setNotesActive] = useState(true);

  const handleChangeNama = (event) => {
    const value = event.target.value;
    if (value) {
      clearError("name_sender");
      setNamaActive(false);
      handleEnableButton(false, emailActive, notesActive);
    } else {
      setError("name_sender", "required", "Nama wajib diisi");
      setNamaActive(true);
      handleEnableButton(true, emailActive, notesActive);
    }
  };

  const handleChangeEmail = (event) => {
    const value = event.target.value;
    if (value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      clearError("email");
      setEmailActive(false);
      handleEnableButton(namaActive, false, notesActive);
    } else {
      setError("email", "required", "Format email tidak valid");
      setEmailActive(true);
      handleEnableButton(namaActive, true, notesActive);
    }
  };

  const handleChangeNotes = (event) => {
    const value = event.target.value;
    if (value) {
      clearError("pesan");
      setNotesActive(false);
      handleEnableButton(namaActive, emailActive, false);
    } else {
      setError("pesan", "required", "Pesan tidak boleh kosong");
      setNotesActive(true);
      handleEnableButton(namaActive, emailActive, true);
    }
  };

  const handleEnableButton = (nActive, eActive, notesAct) => {
    if (!nActive && !eActive && !notesAct) {
      setActive(false);
    } else {
      setActive(true);
    }
  };

  const onSubmit = (data, e) => {
    var formData = new FormData();
    formData.append("name", data.name_sender);
    formData.append("email", data.email);
    formData.append("message", data.pesan);
    setOpenTime(true);

    postEmailToAdmin(formData).then((result) => {
      if (result.success === 1) {
        setOpenTime(false);
        sendEmailToSender(formData).then(() => {
          setOpen(true);
          setEmailActive(true);
          setNamaActive(true);
          setNotesActive(true);
        });
      } else {
        alert(result.msg);
        setOpenTime(false);
      }
    });

    e.target.reset();
    setActive(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseTime = () => {
    setOpenTime(false);
  };

  return (
    <div
      style={{
        maxWidth: "100%",
        overflowX: "hidden",
        backgroundColor: "#ffffff",
      }}
    >
      <MetaTags>
        <title>Hubungi Kami | UR - Self Order &amp; POS App</title>
        <meta name="title" content="Hubungi Kami | UR" />
        <meta
          name="description"
          content="Hubungi tim support dan sales UR Partner. Kami siap membantu pertanyaan dan kebutuhan bisnis Anda."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ur-hub.com/contact" />
      </MetaTags>

      {/* Header Banner */}
      <section
        style={{
          paddingTop: "130px",
          paddingBottom: "64px",
          backgroundColor: "#0f172a",
          color: "#ffffff",
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={4}
            alignItems="center"
            justify="space-between"
          >
            <Grid item xs={12} md={7}>
              <div
                style={{
                  color: "#DE148C",
                  fontSize: "13px",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  marginBottom: "12px",
                }}
              >
                Bantuan &amp; Konsultasi
              </div>

              <Typography
                variant="h1"
                style={{
                  fontWeight: 800,
                  fontSize: "clamp(2rem, 4vw, 3.2rem)",
                  lineHeight: 1.2,
                  letterSpacing: "-0.02em",
                  marginBottom: "14px",
                }}
              >
                Hubungi Tim Kami
              </Typography>

              <Typography
                variant="subtitle1"
                style={{
                  color: "#94a3b8",
                  fontSize: "15px",
                  lineHeight: 1.6,
                  maxWidth: "520px",
                }}
              >
                Tim Customer Success dan Technical Consultant kami siap membantu
                kebutuhan dan pertanyaan Anda.
              </Typography>
            </Grid>

            {/* Illustration */}
            <Grid item xs={12} md={5} style={{ textAlign: "center" }}>
              <img
                src="../../asset/images/Illustration/contactUs.png"
                alt="Contact Us"
                style={{
                  maxHeight: "220px",
                  width: "auto",
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </section>

      {/* Form & Contact Channels Section */}
      <section style={{ padding: "64px 0 80px 0", backgroundColor: "#f8fafc" }}>
        <Container maxWidth="lg">
          <Grid
            container
            spacing={5}
            alignItems="flex-start"
            justify="space-between"
          >
            {/* Contact Form Card */}
            <Grid item xs={12} md={7}>
              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "16px",
                  padding: "36px 28px",
                  border: "1px solid #e2e8f0",
                }}
              >
                <Typography
                  variant="h4"
                  style={{
                    fontWeight: 800,
                    color: "#0f172a",
                    fontSize: "22px",
                    marginBottom: "6px",
                  }}
                >
                  Kirim Pesan
                </Typography>
                <p
                  style={{
                    color: "#64748b",
                    fontSize: "14px",
                    marginBottom: "24px",
                  }}
                >
                  Isi formulir di bawah dan kami akan membalas melalui email
                  secepatnya.
                </p>

                <form onSubmit={handleSubmit(onSubmit)}>
                  <div style={{ marginBottom: "16px" }}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      inputRef={register({
                        required: "Nama lengkap wajib diisi",
                      })}
                      onChange={handleChangeNama}
                      label="Nama Lengkap"
                      name="name_sender"
                    />
                    {errors.name_sender && (
                      <small
                        style={{
                          color: "#ef4444",
                          fontSize: "12px",
                          marginTop: "4px",
                          display: "block",
                        }}
                      >
                        {errors.name_sender.message}
                      </small>
                    )}
                  </div>

                  <div style={{ marginBottom: "16px" }}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={register({ required: "Email wajib diisi" })}
                      onChange={handleChangeEmail}
                      label="Alamat Email"
                      name="email"
                    />
                    {errors.email && (
                      <small
                        style={{
                          color: "#ef4444",
                          fontSize: "12px",
                          marginTop: "4px",
                          display: "block",
                        }}
                      >
                        {errors.email.message}
                      </small>
                    )}
                  </div>

                  <div style={{ marginBottom: "20px" }}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      inputRef={register({ required: "Pesan wajib diisi" })}
                      onChange={handleChangeNotes}
                      label="Tuliskan pesan atau pertanyaan Anda..."
                      name="pesan"
                      multiline
                      rows={4}
                    />
                    {errors.pesan && (
                      <small
                        style={{
                          color: "#ef4444",
                          fontSize: "12px",
                          marginTop: "4px",
                          display: "block",
                        }}
                      >
                        {errors.pesan.message}
                      </small>
                    )}
                  </div>

                  <Button
                    type="submit"
                    variant="contained"
                    disabled={active}
                    style={{
                      backgroundColor: active ? "#cbd5e1" : "#DE148C",
                      color: "#ffffff",
                      fontWeight: 600,
                      fontSize: "14px",
                      padding: "10px 24px",
                      borderRadius: "8px",
                      textTransform: "none",
                      boxShadow: "none",
                    }}
                  >
                    Kirim Pesan
                  </Button>
                </form>
              </div>
            </Grid>

            {/* Direct Contact Details */}
            <Grid item xs={12} md={5}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                {/* WhatsApp Channel Card */}
                <a
                  href="https://wa.me/6287777077771"
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      borderRadius: "14px",
                      padding: "20px",
                      border: "1px solid #e2e8f0",
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                      transition: "border-color 0.2s ease",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.borderColor = "#cbd5e1";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.borderColor = "#e2e8f0";
                    }}
                  >
                    <div
                      style={{
                        width: "44px",
                        height: "44px",
                        borderRadius: "10px",
                        backgroundColor: "#f0fdf4",
                        color: "#16a34a",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <CallIcon />
                    </div>
                    <div>
                      <div
                        style={{
                          color: "#64748b",
                          fontSize: "12px",
                          fontWeight: 600,
                          textTransform: "uppercase",
                        }}
                      >
                        WhatsApp Hotline
                      </div>
                      <div
                        style={{
                          color: "#0f172a",
                          fontSize: "15px",
                          fontWeight: 700,
                        }}
                      >
                        087-7770-7777-1
                      </div>
                    </div>
                  </div>
                </a>

                {/* Email Card */}
                <a
                  href="mailto:support@ur-hub.com"
                  style={{ textDecoration: "none" }}
                >
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      borderRadius: "14px",
                      padding: "20px",
                      border: "1px solid #e2e8f0",
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                      transition: "border-color 0.2s ease",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.borderColor = "#cbd5e1";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.borderColor = "#e2e8f0";
                    }}
                  >
                    <div
                      style={{
                        width: "44px",
                        height: "44px",
                        borderRadius: "10px",
                        backgroundColor: "#f0f9ff",
                        color: "#0284c7",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <EmailIcon />
                    </div>
                    <div>
                      <div
                        style={{
                          color: "#64748b",
                          fontSize: "12px",
                          fontWeight: 600,
                          textTransform: "uppercase",
                        }}
                      >
                        Email Dukungan
                      </div>
                      <div
                        style={{
                          color: "#0f172a",
                          fontSize: "15px",
                          fontWeight: 700,
                        }}
                      >
                        support@ur-hub.com
                      </div>
                    </div>
                  </div>
                </a>

                {/* Operating Info Card */}
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "14px",
                    padding: "20px",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <div
                    style={{
                      color: "#0f172a",
                      fontWeight: 700,
                      fontSize: "14px",
                      marginBottom: "4px",
                    }}
                  >
                    Kantor Operasional
                  </div>
                  <p
                    style={{
                      color: "#64748b",
                      fontSize: "13px",
                      lineHeight: 1.6,
                      margin: 0,
                    }}
                  >
                    PT. Rahmat Tuhan Lestari
                    <br />
                    Bandung, Jawa Barat, Indonesia
                  </p>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </section>

      {/* Progress Dialog */}
      <Dialog open={openTime} onClose={handleCloseTime}>
        <DialogTitle>Mengirim Pesan</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Mohon menunggu sejenak, pesan Anda sedang diproses...
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/* Success Dialog */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Pesan Terkirim</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Terima kasih telah menghubungi kami. Pesan Anda telah kami terima
            dan tim kami akan segera membalas melalui email.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Selesai
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
